var React = require('react');

function Telegram (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.8667 2.09876L2.1344 7.16435C2.02204 7.21117 1.96586 7.34225 2.02204 7.45461C2.04077 7.50143 2.06886 7.53888 2.11567 7.55761L4.84978 9.16811C4.87787 9.18684 4.90596 9.21493 4.91532 9.25238L6.17002 12.979C6.20747 13.0914 6.33856 13.1569 6.45092 13.1195C6.48837 13.1101 6.51646 13.0914 6.54455 13.0633L8.18314 11.3123C8.22996 11.2655 8.30487 11.2561 8.36105 11.2842L10.4678 12.4359C10.5708 12.4921 10.7113 12.4547 10.7674 12.3517C10.7768 12.3423 10.7768 12.3236 10.7862 12.3142L14.1663 2.37966C14.2038 2.2673 14.1476 2.13622 14.0259 2.09876C13.9697 2.08004 13.9135 2.08004 13.8667 2.09876ZM6.99399 10.1138L6.38537 11.8179L5.50522 9.13066L11.9098 4.25234L6.99399 10.1138Z","fill":"#443F8B","fillOpacity":"0.8"}));
}

Telegram.defaultProps = {"width":"16","height":"15","viewBox":"0 0 16 15","fill":"none"};

module.exports = Telegram;

Telegram.default = Telegram;
